export const hasFormValuesChanged = <T extends Record<string, unknown>>(
  watchedValues: T[keyof T][],
  defaultValues: T,
  keys: readonly (keyof T)[]
): boolean => {
  return keys.some((key, index) => {
    const watchedValue = watchedValues[index];
    const defaultValue = defaultValues[key];

    if (Array.isArray(defaultValue)) {
      return (
        !Array.isArray(watchedValue) ||
        defaultValue.length !== watchedValue.length ||
        defaultValue.some((v, i) => v !== (watchedValue as unknown[])[i])
      );
    }

    return defaultValue !== watchedValue;
  });
};
